import React from 'react';
import { Countdown } from './Countdown';
import { PlanCards } from './PlanCards';
import { Emoji } from './Emoji';
const trust = [{
  emoji: '🔒',
  label: 'Pago 100% seguro'
}, {
  emoji: '⚡',
  label: 'Acceso en 5 minutos'
}, {
  emoji: '🛡️',
  label: 'Garantía 7 días'
}, {
  emoji: '💳',
  label: 'Mercado Pago — Tarjeta — Transferencia'
}];
export function CierreFinal() {
  return <section className="w-full bg-white py-14 sm:py-16" data-id="element-39" data-mp="i9u3s6faz6e7">
      <div className="mx-auto w-full max-w-[680px] px-4 sm:px-6 lg:max-w-content" data-id="element-40" data-mp="iaca5vvoj0zu">
        <h2 className="text-center font-display text-[clamp(1.5rem,6vw,2.25rem)] font-extrabold uppercase leading-[1.08] tracking-tight text-ink-900" data-id="element-41" data-mp="dcaod36vcnko">
          El precio cierra pronto. No vuelve.
        </h2>

        <div className="mt-8" data-id="element-42" data-mp="n7lyf87c16m3">
          <Countdown label="El precio cierra en:" data-id="element-43" data-mp="23nf1hohl0ycl" />
        </div>

        <div className="mt-10 sm:mt-12" data-id="element-44" data-mp="23lvme17nwtce">
          <PlanCards data-id="element-45" data-mp="1yolxcmo6qjp3" />
        </div>

        <ul className="mt-10 flex flex-col items-center gap-3 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-x-7" data-id="element-46" data-mp="1ynk9tipzg4qh">
          {trust.map(item => <li key={item.label} className="inline-flex items-center gap-2 text-[13px] text-ink-500 sm:text-sm" data-id="element-47" data-mp="27ccc5a3afv68">
              <Emoji symbol={item.emoji} data-id="element-48" data-mp="2cbxdts9uehmn" />
              {item.label}
            </li>)}
        </ul>
      </div>
    </section>;
}